<template>
  <div class="data-fetch-error typo-tiny">
    {{ $t('general.data_fetch_error') }}
  </div>
</template>

<script setup></script>

<style scoped lang="scss">
@import '@/stylesheets/global';

.data-fetch-error {
  align-items: center;
  color: map-get($foreground-color, dark);
  display: flex;
  font-style: italic;
  height: 100%;
  justify-content: center;
  padding: bu(2);
  width: 100%;
}

</style>
